import { Dispatch, SetStateAction } from 'react';

import { LogSelectionOption } from '~/shared/utils/types';

import SearchFilter from './SearchFIlter';
import { FilterTag } from './FilterTag';

export default function LogFilter({
  filters,
  setFilters,
}: {
  filters: LogSelectionOption[];
  setFilters: Dispatch<SetStateAction<LogSelectionOption[]>>;
}) {
  return (
    <div className="flex mb-[36px] gap-[16px] flex-1">
      <SearchFilter setFilters={setFilters} />
      <div className="flex gap-[16px] flex-wrap">
        {filters?.map((filter, i) => (
          <FilterTag
            key={i}
            filter={filter}
            onClose={() => setFilters((prev) => prev.filter((_, index) => index !== i))}
          />
        ))}
      </div>
    </div>
  );
}
